import { render, staticRenderFns } from "./AssetTable.vue?vue&type=template&id=0038782f&scoped=true&"
import script from "./AssetTable.vue?vue&type=script&lang=js&"
export * from "./AssetTable.vue?vue&type=script&lang=js&"
import style0 from "./AssetTable.vue?vue&type=style&index=0&id=0038782f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0038782f",
  null
  
)

export default component.exports